export const PAGES = [
  {
    key: "largeMap",
    title: "地形图",
    visible: true,
    index: 0,
    mapSettings: true,
    mapCount: 1,
    rightsider: {
      visible: true, // 是否显示右边栏
      isMapBoolen: false, // 右边栏是否显示地形图
      isScaleBoolen: false, // 右边栏是否显示屏陡K指示
      isImageBoolen: true
    }
  },
  {
    key: "fourMaps",
    title: "四联图",
    visible: true,
    index: 1,
    mapSettings: true,
    mapCount: 4,
    rightsider: {
      visible: true,
      isMapBoolen: false,
      isScaleBoolen: false,
      isImageBoolen: true
    }
  },
  {
    key: "mainMeridian",
    title: "形态因子",
    visible: true,
    index: 2,
    mapSettings: true,
    mapCount: 2,
    rightsider: {
      visible: true,
      isMapBoolen: false,
      isScaleBoolen: false,
      isImageBoolen: true
    }
  },
  {
    key: "zernike",
    title: "Zernike",
    visible: true,
    index: 3,
    mapSettings: true,
    mapCount: 1,
    rightsider: {
      visible: false,
      isMapBoolen: false,
      isScaleBoolen: false,
      isImageBoolen: true
    }
  },
  {
    key: "keratoconus",
    title: "圆锥角膜",
    visible: false,
    index: 4,
    mapSettings: true,
    mapCount: 3,
    rightsider: {
      visible: true,
      isMapBoolen: false,
      isScaleBoolen: false,
      isImageBoolen: true
    }
  },
  {
    key: "contectlens",
    title: "接触镜",
    visible: false,
    index: 5,
    mapSettings: true,
    mapCount: 1,
    rightsider: {
      visible: false,
      isMapBoolen: false,
      isScaleBoolen: false,
      isImageBoolen: true
    }
  },
  {
    key: "compare2records",
    title: "检查结果对比",
    visible: true,
    index: 6,
    mapSettings: true,
    mapCount: 3,
    rightsider: {
      visible: false,
      isMapBoolen: false,
      isScaleBoolen: false,
      isImageBoolen: true
    }
  }
];



// WEBPACK FOOTER //
// ./src/topography/config/pages.js